
import filters from "@/filters";
import { Component, Vue } from "vue-property-decorator";
import AppLayout from "@/layouts/AppLayout.vue";
import { Action } from "vuex-class";
import { AxiosResponse } from "axios";
import moment from "moment";
import BarChart from "@/components/charts/BarChart.vue";
@Component({
  components: {
    BarChart,
    AppLayout,
  },
  filters,
})
export default class EventActivityStats extends Vue {
  @Action("getAdminJobFairDetail", { namespace: "admin" })
  private getAdminJobFairDetail: any;
  @Action("getAdminJobFairOrganizerChartAttendance", { namespace: "admin" })
  private getAdminJobFairOrganizerChartAttendance: any;
  @Action("getAdminJobFairOrganizerChartDailyAttendance", {
    namespace: "admin",
  })
  private getAdminJobFairOrganizerChartDailyAttendance: any;
  @Action("getAdminJobFairOrganizerChartCompany", { namespace: "admin" })
  private getAdminJobFairOrganizerChartCompany: any;

  private jobFair: any = null;
  private interval: any = null;
  private currentClock = this.getDateClock();
  private candidateAttendanceChart = {
    labels: ["Hadir", "Tidak hadir"],
    datasets: [
      {
        data: [0, 0],
        backgroundColor: ["#17B284", "#EDA519"],
      },
    ],
    customData: {
      total: 0,
    },
  };
  private companyChart = {
    company: 0,
    application: 0,
    job: 0,
  };
  private candidateDailyAttendanceChart = {
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: "#17BAB2",
      },
    ],
  };
  private barChartOptions = {
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            stepSize: 1,
          },
        },
      ],
    },
  };

  private get isJobFairStarted() {
    if (this.jobFair)
      return moment(moment()).utc().isSameOrAfter(this.jobFair.start_date);
    else return false;
  }
  private get isJobFairEnded() {
    if (this.jobFair)
      return moment(moment()).utc().isAfter(this.jobFair.end_date);
    else return false;
  }
  private get isJobFairEndedToday() {
    if (this.jobFair)
      return (
        this.isJobFairEnded &&
        moment(moment()).utc().isSame(this.jobFair.end_date, "day")
      );
    else return false;
  }

  private created() {
    this.getData();
    this.getMetrics();

    this.interval = setInterval(() => {
      this.currentClock = this.getDateClock();
      this.websocketWatcher();
    }, 1000);
  }

  private mounted() {
    window.onresize = () => this.setChartHeight();
  }

  private beforeDestroy() {
    clearInterval(this.interval);
  }

  private setChartHeight() {
    let height = Math.abs(
      window.innerHeight -
        document.getElementsByClassName("row")[0].clientHeight -
        document.getElementsByClassName("row")[1].clientHeight -
        document.getElementsByClassName("row")[2].clientHeight -
        70
    );
    (document.getElementById("bar-chart") as any).style.height = `${height}px`;
  }

  private getData() {
    this.getAdminJobFairDetail({
      params: {
        slug: this.$route.params.slug,
      },
      success: (response: AxiosResponse) => {
        this.jobFair = response.data.data;
      },
    });
  }

  private getMetrics() {
    this.getAdminJobFairOrganizerChartAttendance({
      success: (response: AxiosResponse) => {
        this.setChartAttendance(response.data.data);
      },
    });
    this.getAdminJobFairOrganizerChartDailyAttendance({
      success: (response: AxiosResponse) => {
        this.setChartDailyAttendance(response.data.data);
      },
    });
    this.getAdminJobFairOrganizerChartCompany({
      success: (response: AxiosResponse) => {
        this.setChartCompany(response.data.data);
      },
    });
  }

  private websocketWatcher() {
    (window as any).socket.onmessage = (event) => {
      const data = JSON.parse(event?.data);
      switch (data.chart) {
        case "attendance":
          this.setChartAttendance(data.data);
          break;
        case "daily-attendance":
          this.setChartDailyAttendance(data.data);
          break;
        case "company":
          this.setChartCompany(data.data);
          break;
      }
    };
  }

  private setChartAttendance(data) {
    this.candidateAttendanceChart.datasets[0].data[0] = data.present;
    this.candidateAttendanceChart.datasets[0].data[1] = data.absent;
    this.candidateAttendanceChart.customData.total = data.total;
  }

  private setChartDailyAttendance(data) {
    this.candidateDailyAttendanceChart = {
      ...this.candidateDailyAttendanceChart,
      labels: data.map((value) => moment(value.interval).utc().format("HH:mm")),
      datasets: [
        {
          data: data.map((value) => value.data),
          backgroundColor: "#17BAB2",
        },
      ],
    };
    setTimeout(() => {
      this.setChartHeight();
    }, 50);
  }

  private setChartCompany(data) {
    this.companyChart.company = data.company;
    this.companyChart.application = data.application;
    this.companyChart.job = data.job;
    this.getData();
  }

  private getDateClock() {
    const currentTime = moment().local();
    const date = currentTime.format("dddd, DD MMMM YYYY");
    const time = currentTime.format("HH:mm:ss");
    return { date, time, currentTime };
  }
}
